import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=11d18e64"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"
import style0 from "./YoutubePlayer.vue?vue&type=style&index=0&id=11d18e64&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11d18e64')) {
      api.createRecord('11d18e64', component.options)
    } else {
      api.reload('11d18e64', component.options)
    }
    module.hot.accept("./YoutubePlayer.vue?vue&type=template&id=11d18e64", function () {
      api.rerender('11d18e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SharedVideo/Players/YoutubePlayer.vue"
export default component.exports